import React from 'react'
import { CFView, Space, Text, HorizontalLine } from 'components'
import { css } from 'emotion'
import { MEDIA_QUERY } from 'styles'
import { moment } from 'cf-utils'

const OrderDetailsView = ({
  orderType,
  orderNumber,
  createdAt,
  OrderStatusElement,
  ProductListElement,
  RewardListElement,
  DiscountElement,
  AddedChargesElement,
  subTotalFormatted,
  deliveryFeeFormatted,
  tipFormatted,
  taxFormatted,
  totalFormatted,
}) => (
  <div className={styles.orderDetails}>
    <CFView fill row justifyBetween alignCenter>
      <Text heading h1 red>{`#${orderNumber}`}</Text>
      <Text heading h3 white>{`${moment(createdAt).format('MMMM D')}, ${moment(
        createdAt
      ).format('LT')}`}</Text>
    </CFView>
    <Space h3 />
    <CFView fill row justifyCenter alignCenter>
      {OrderStatusElement}
    </CFView>
    <Space h3 />
    <div>
      {ProductListElement}
      {RewardListElement}
      {DiscountElement}
      {AddedChargesElement}
    </div>
    <Space h1 />
    <HorizontalLine />
    <Space h1 />
    <div className={styles.column}>
      <div className={styles.productItem}>
        <Text content h4 white>
          Subtotal
        </Text>
        <Text content h4 white>{`$${subTotalFormatted}`}</Text>
      </div>
      {orderType === 'Delivery' && (
        <div className={styles.productItem}>
          <Text content h4 white>
            Delivery Fee
          </Text>
          <Text content h4 white>{`$${deliveryFeeFormatted}`}</Text>
        </div>
      )}
      <div className={styles.productItem}>
        <Text content h4 white>
          GST (5%)
        </Text>
        <Text content h4 white>{`$${taxFormatted}`}</Text>
      </div>
      {Number(tipFormatted) > 0 && (
        <div className={styles.productItem}>
          <Text content h4 white>
            Tip
          </Text>
          <Text content h4 white>{`$${tipFormatted}`}</Text>
        </div>
      )}
      <div className={styles.productItem}>
        <Text content h4 white>
          Total
        </Text>
        <Text content h4 white>{`$${totalFormatted}`}</Text>
      </div>
    </div>
  </div>
)

const styles = {
  orderDetails: css({
    backgroundColor: '#232323',
    color: 'white',
    borderRadius: '1rem',
    display: 'flex',
    flexDirection: 'column',
    width: '60rem',
    [MEDIA_QUERY.SM]: {
      width: '100%',
    },
  }),
  column: css({
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  productItem: css({
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
  }),
}

export default OrderDetailsView
